import { Component, OnInit } from "@angular/core";
import { trigger, state, style, transition, animate } from "@angular/animations";
import { ActivatedRoute, Router } from "@angular/router";

import swal from "bootstrap-sweetalert";

import { AuthenticationService } from "app/services/authentication.service";

// высота контейнера области ввода данных
const containerHeightPx = 380;

@Component({
  templateUrl: "sign-in.component.html",
  styleUrls: ["sign-in.component.scss"]
})
export class SignInComponent implements OnInit {

  private _returnUrl: string;

  username: string;
  password: string;

  signInState = "idle";

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    // reset sign in status
    this._authenticationService.signOut();

    // get return url from route parameters or default to '/'
    this._returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';
  }

  signin() {
    this._signinError = null;
    this._authenticationService.signIn(this.username, this.password)
      .subscribe(
        user => {
          this.signInState = "signedIn";
          setTimeout(() => {
            this._router.navigate([this._returnUrl]);
          }, 1000);
        },
        error => {
          console.error(error);

          switch (error as AuthenticationService.SigninError) {
            case "InvalidUserNameOrPassword":
              this._signinError = "Неверные имя пользователя либо пароль";
              break;
            case "SaltAlreadyUsed":
              this._signinError = "Внутренняя ошибка. Попробуйте снова";
              break;
            case "UserNotActivated":
              this._signinError = "Пользователь не активирован";
              break;
            case "UserIsLocked":
              this._signinError = "Пользователь заблокирован";
              break;
            case "ClientIsLocked":
              this._signinError = "У вашей компании заблокирован доступ к сервису \"Личный кабинет клиента\"";
              break;
            case "PasswordResetRequired":
              swal('Уведомление', 'Мы изменили парольную политику в системе для безопасности Вашей учетной записи. На вашу почту была отправлена ссылка для указания нового пароля', 'warning');
              break;
            default:
              this._signinError = "Неизвестная ошибка";
          }
        });
  }

  private _signinError: string = null;
}



// WEBPACK FOOTER //
// /app/SPA/src/app/account/sign-in/sign-in.component.ts